import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { useReducedMotionSafe } from "@/components/animation/AnimationSettings";
import { PALETTE, buildSparkline } from "@/components/animation/MotionShared";

/**
 * Subtle cinematic background of low-opacity floating candles. Decorative.
 * Sits absolute/full inside its parent (parent must be `position: relative`).
 */
export default function FloatingCandlesticks({ count = 14, testid = "floating-candlesticks" } = {}) {
  const reduce = useReducedMotionSafe();
  const candles = useMemo(() => {
    const arr = [];
    const lane = buildSparkline({ seed: "floating", points: count, base: 50, vol: 14 });
    for (let i = 0; i < count; i += 1) {
      const y = 6 + (lane[i] + 30) * 0.7;
      const x = (i / count) * 100;
      const up = i % 2 === 0;
      arr.push({ x, y, up, delay: i * 0.18 });
    }
    return arr;
  }, [count]);
  return (
    <div style={S.shell} aria-hidden="true" data-testid={testid}>
      {candles.map((c, i) => (
        <motion.div
          key={i}
          style={{
            ...S.candle,
            left:   `${c.x}%`,
            top:    `${c.y}%`,
            background: c.up ? "rgba(16,185,129,0.18)" : "rgba(239,68,68,0.18)",
            border:     `1px solid ${c.up ? "rgba(16,185,129,0.35)" : "rgba(239,68,68,0.35)"}`,
          }}
          animate={reduce ? {} : { y: [0, -6, 0], opacity: [0.0, 0.6, 0.0] }}
          transition={reduce ? { duration: 0 } : { delay: c.delay, duration: 6 + (i % 3), repeat: Infinity, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
}

const S = {
  shell: { position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" },
  candle: { position: "absolute", width: 6, height: 22, borderRadius: 2, transform: "translate(-50%, -50%)", boxShadow: "0 0 12px rgba(197,160,89,0.08)" },
};
